// Copyright (c) 2026 Otyka LLC. All rights reserved.

import React, { useState } from 'react';
import { login, completeNewPassword } from './auth';

export default function LoginPage({ onSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [challengeUser, setChallengeUser] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const result = await login(email, password);
      if (result.newPasswordRequired) {
        setChallengeUser(result.user);
      } else {
        onSuccess();
      }
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  async function handleNewPassword(e) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await completeNewPassword(challengeUser, newPassword);
      onSuccess();
    } catch (err) {
      setError(err.message || 'Failed to set new password');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login">
      <div className="login__card">
        <h1 className="login__title">Platform Admin</h1>
        <p className="login__subtitle">Sign in to manage tenants</p>

        {!challengeUser ? (
          <form onSubmit={handleSubmit} className="login__form">
            <label className="login__label">
              Email
              <input
                type="email"
                className="login__input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                autoFocus
              />
            </label>
            <label className="login__label">
              Password
              <input
                type="password"
                className="login__input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </label>
            {error && <p className="login__error">{error}</p>}
            <button className="login__btn" type="submit" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleNewPassword} className="login__form">
            <p className="login__note">You must set a new password to continue.</p>
            <label className="login__label">
              New Password
              <input
                type="password"
                className="login__input"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                autoComplete="new-password"
                minLength={12}
                autoFocus
              />
            </label>
            {error && <p className="login__error">{error}</p>}
            <button className="login__btn" type="submit" disabled={loading}>
              {loading ? 'Setting password…' : 'Set Password & Continue'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
